import styled from '@emotion/styled';
import React from 'react';

export type StyledDivIconProps = React.HTMLAttributes<HTMLDivElement>;

const StyledDivIcon = styled.div<StyledDivIconProps>(
  {
    alignItems: 'center',
    display: 'inline-flex',
    height: '100%',
    justifyContent: 'flex-end',
    padding: '21.5px 0',
    width: '100%'
  },
  ({ theme }) => ({
    color: theme.palette.colors.white
  })
);

export default StyledDivIcon;
